<template>
  <div class="z_detail_vue">
    <div class="z_breadcrumb">
      <div class="z_content">
        <svg-icon className="icon" icon-class="nav_header1" />
        <span>当前位置： </span>
        <span>首页</span>
        <svg-icon className="icon" icon-class="right" />
        <span>详情</span>
      </div>
    </div>

  
    <div class="z_detail">
      <div class="z_content">
      <div class="timeul" v-if="isNotice" style="text-align: center; margin-bottom:25px">
      <a-radio-group v-model="value" button-style="solid">
          <a-radio-button value="21" :disabled="datetime1.length>2?false:true" v-on:click="GetBulletData(bulletinId1)">采购公告<div class="shixin" style="display:none"></div></a-radio-button>
          <a-radio-button value="23" :disabled="datetime2.length>2?false:true" v-on:click="change<2?GetBulletData(bulletinId2):GetBulletData(ChangeMentList[0].autoId)">变更公告<div class="shixin" style="display:none"></div></a-radio-button>
          <a-radio-button value="22" :disabled="datetime4.length>2?false:true" v-on:click="GetBulletData(bulletinId4)">结果公告<div class="shixin" style="display:none"></div></a-radio-button>
        </a-radio-group>
          <a-timeline mode="right" style="margin: -80px 0 -145px 47%;">
    <a-timeline-item>
        <template #dot>
         <svg-icon v-if="value!=21&&datetime1.length>2" style="transform: rotate(90deg); width:26px" className="bid-card-svg" icon-class="timetrue" />
         <svg-icon v-if="value!=21&&datetime1.length<2" style="transform: rotate(90deg); width:26px" className="bid-card-svg" icon-class="timenull" />
         <svg-icon v-if="value==21" style="transform: rotate(90deg); width:32px; height:32px;padding:2px 0;border-color: #1890ff;" className="statistics-svg" icon-class="timetruecheck" />
         </template>
          <span :style="value==21?'color:#1890ff;':''">{{datetime1}}</span>
      </a-timeline-item><br/>
    <a-timeline-item>
        <template #dot>
         <svg-icon v-if="value!=23&&datetime2.length>2" style="transform: rotate(90deg); width:26px" className="bid-card-svg" icon-class="timetrue" />
         <svg-icon v-if="value!=23&&datetime2.length<2" style="transform: rotate(90deg); width:26px" className="bid-card-svg" icon-class="timenull" />
         <svg-icon v-if="value==23" style="transform: rotate(90deg); width:32px; height:32px;padding:2px 0;border-color: #1890ff;" className="statistics-svg" icon-class="timetruecheck" />
         </template>
          <span :style="value==23?'color:#1890ff;':''">{{datetime2}}</span>
      </a-timeline-item><br/>
    <a-timeline-item>
        <template #dot>
         <svg-icon v-if="value!=22&&datetime4.length>2" style="transform: rotate(90deg); width:26px" className="bid-card-svg" icon-class="timetrue" />
         <svg-icon v-if="value!=22&&datetime4.length<2" style="transform: rotate(90deg); width:26px" className="bid-card-svg" icon-class="timenull" />
         <svg-icon v-if="value==22" style="transform: rotate(90deg); width:32px; height:32px;padding:2px 0;border-color: #1890ff;" className="statistics-svg" icon-class="timetruecheck" />
         </template>
          <span :style="value==22?'color:#1890ff;':''">{{datetime4}}</span>
      </a-timeline-item><br/>
  </a-timeline>
  <div style="margin-top:25px;">
  <a-table  v-if="value==23&&change>1" style="width: 80%;margin:auto;" bordered :columns="columns" :data-source="ChangeMentList" :rowKey="ChangeMentList=>ChangeMentList.autoId" :pagination="false">
      <span slot="autoId" slot-scope="text">
          <a v-on:click="GetBulletData(text)">查看</a><!-- :style="changeid==text?'color:white':''" -->
      </span>
  </a-table>
  </div>
      </div>
        <div class="z_title">
          <!-- 搜索结果页显示⤵️ -->
          <!-- <h2>找到关于“这个段很长的关键字”，共2311个结果</h2> -->
          <!-- 文章页显示⤵️ -->
          <div v-if="!type">
            <h1>{{ DetailData.title }}</h1>
            <span>发布日期：{{ DetailData.publishdate | moment_d }}</span
            >&nbsp;
            <span>阅读人数：{{ DetailData.readNum }}</span>
          </div>
        </div>
        <BigImg v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></BigImg>
        <div class="z_detail_content">
          <!-- 这理是文章内容 -->
          <div v-if="!type" style="padding: 24px 50px">
            <div @click="ClickBigImg" v-html="DetailData.content"></div>
            <div v-if="fileList&&fileList.length>0">
              附件：
              <div v-for="item of fileList" :key="item">
              <a :href="'https://ygcg.nbcqjy.org:8076/api/Download/'+item.fileId" target="_blank">
                {{ item.fileName }}
              </a>
              </div>
            </div>
            <div style="text-align: center">
              <a-button v-if="Datebtn==1" type="primary" @click="buyBid()" disabled >未开始</a-button>
              <a-button v-if="Datebtn==2" type="primary" @click="buyBid()">下载采购文件</a-button>
              <a-button v-if="Datebtn==3" type="primary" @click="buyBid()" disabled >已结束</a-button>
            </div>
          </div>
      
          <div
            v-else-if="type == 10"
            class="z_detail_iframe"
            style="padding: 24px 0"
          >
            <!-- <iframe
              width="100%"
              hight="auto"
              frameborder="0"
              scrolling="auto"
              id="mainiframe"
              :src="iframeSrc2"
            ></iframe> -->
            <Winbulletin
               :TextList="{
                  prjId: iframeSrc,
                }"
          ></Winbulletin>
          </div>

          <div v-else class="z_detail_iframe" style="padding: 24px 0">
            <!-- <iframe
              width="100%"
              hight="auto"
              frameborder="0"
              scrolling="auto"
              id="mainiframe"
              :src="iframeSrc"
            ></iframe> -->
            <Bulletin
               :TextList="{
                  prjId: iframeSrc,
                }"
          ></Bulletin>
          </div>
          <!-- <div v-else-if="type === '1'">
            <a-list
              v-if="subtype == '1'"
              :pagination="pagination"
              :data-source="data.projectList"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{ item.prjName }}</span>
                </a-list-item-meta>
                <div>{{ item.kbDate | moment }}</div>
              </a-list-item>
            </a-list>
            <a-list
              v-if="subtype == '0'"
              :pagination="pagination"
              :data-source="data"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{ item.title }}</span>
                </a-list-item-meta>
                <div>{{ item.publishDate | moment }}</div>
              </a-list-item>
            </a-list>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetById } from "@/api/article";
import { GetBulletinContent } from "@/api/protal";
import { GetBulletin } from "@/api/protal";
import { GetNewsContent } from "@/api/protal";
import BigImg from "@/components/BigImg/bigimg.vue"
import Bulletin from "@/components/BulletinTab/bulletin.vue";
import Winbulletin from "@/components/WinBulletin/winbulletin.vue";
import moment from "moment";
// import moment from "moment";
var bulletinList = {};
const columns = [
  {
    title: "公告标题",
    dataIndex:'bulletinTitle',
  },
  
  {
    title: '操作',
    dataIndex: 'autoId',
    slots: { title: 'autoId' },
    scopedSlots: { customRender: 'autoId' },
  },
];
export default {
  data() {
    const value = '0';
    return {
      DetailData: {
        publishdate: "",
        title: "",
        content: "",
        prjId: "",

      },
      fileList: [],
      imgSrc: "",
      showImg: false,
      buyBtnShow: false,
      bulletinList,
      value,
      isNotice:false,
      datetime1:'　',
      datetime2:'　',
      datetime4:'　',
      bulletinId1:'',
      bulletinId2:'',
      bulletinId4:'',
      change: 0,
      ChangeMentList:[],
      columns,
      changeid:0,
      Datebtn:0
    };
  },
  components: {
    Bulletin,
    Winbulletin,
    BigImg,
    },
  computed: {
    articleId() {
      return this.$route.query.articleId;
    },
    bulletinId() {
      return this.$route.query.bulletinId;
    },
    newsId() {
      return this.$route.query.newsId;
    },
    type() {
      return this.$route.query.type;
    },
    iframeSrc() {
      return this.$route.query.prjId;
    },
  },
  created() {},

  mounted() {
    if (!this.type) {
      this.GetData();
    }
  },
  methods: {
    viewImg(){
      this.showImg = false;
    },
    GetData() {
      if (this.articleId) {
        let param = {
          id: Number(this.articleId),
        };
        GetById(param).then((res) => {
          this.DetailData = res.data;
          this.DetailData.publishdate = res.data.publishDate;
          this.DetailData.readNum = res.data.readNum;
          // this.DetailData.content = res.data.content;
          this.DetailData.content = res.data.content.replace('<img','<img data-tagname="authorizationExtension"');
          //   console.log(res);
        });
      } else if (this.bulletinId) {
        let param = {
          autoID: this.bulletinId,
        };
        GetBulletinContent(param).then((res) => {
          this.DetailData.publishdate = res.data.article.publishDate;
          this.fileList = res.data.fileList;
          this.DetailData.title = res.data.article.bulletinTitle;
          this.DetailData.readNum = res.data.article.readNum;
          this.DetailData.content = res.data.article.bulletinContent;
          this.DetailData.prjId = res.data.article.prjId;
          this.theDatebtn(res.data.article.signUpStartDate,res.data.article.signUpEndDate);
          this.value = res.data.article.bulletinTypeId;
          GetBulletin(res.data.article.prjId).then((res) => {
            console.log(res.data);
            var result = 0;
            for(var i=0;i<res.data.length;i++){
              console.log(res.data[i]);
              if(res.data[i].bulletinTypeId==21||res.data[i].bulletinTypeId==25){
                this.datetime1 = res.data[i].publishDate.substr(0,10);
                this.bulletinId1 = res.data[i].autoId;
              }else if(res.data[i].bulletinTypeId==23){
                this.change++;
                if(this.change<2){
                  this.datetime2 = res.data[i].publishDate.substr(0,10);
                this.bulletinId2 = res.data[i].autoId;
                this.ChangeMentList.push(res.data[i]);
                this.changeid = res.data[i].autoId
                }else{
                  this.datetime2 = '共 '+this.change+'个公告'
                  this.ChangeMentList.push(res.data[i]);
                }
              }else if(res.data[i].bulletinTypeId==22){
                result++;
                if(result<2){
                  this.datetime4 = res.data[i].publishDate.substr(0,10);
                  this.bulletinId4 = res.data[i].autoId;
                }else{
                  this.change++;
                  if(this.change==1){
                    this.datetime2 = res.data[i].publishDate.substr(0,10);
                    this.bulletinId2 = res.data[i].autoId;
                    this.ChangeMentList.push(res.data[i]);
                  }else{
                    this.datetime2 = '共 '+this.change+'个公告'
                    this.ChangeMentList.push(res.data[i]);
                  }
                }
              }
            }
          });
          if(res.data.article.bulletinTypeId!=20){
              this.isNotice = true;
              if(res.data.article.prjId==null||res.data.article.prjId==""){
                this.isNotice=false;
              }
          }

          this.buyBtnShow = false;
          if (this.DetailData.prjId) {
            if (
              res.data.article.signUpEndDate &&
              res.data.article.signUpStartDate
            ) {
              let nowdate = new Date();
              let result = moment(nowdate).isBetween(
                res.data.article.signUpStartDate,
                res.data.article.signUpEndDate
              ); //当前时间是否开始时间和结束时间之间
              if (result) {
                this.buyBtnShow = true;
              }
            }
          }
        });
      }else if (this.newsId){
        GetNewsContent(this.newsId).then((res) => {
          this.DetailData.publishdate = res.data.article.publishDate;
          this.DetailData.title = res.data.article.title;
          this.DetailData.readNum = res.data.article.readNum;
          this.DetailData.content = res.data.article.content;
        })
      }
    },

    ClickBigImg(e){
      const tagName = e.target.dataset.tagname
      if (tagName === 'authorizationExtension') {
        // alert(e.target.src)
        this.showImg = true;
        this.imgSrc = e.target.src;
      }
    },
    GetBulletData(bulletinId) {
      let param = {
          autoID: bulletinId,
        };
      GetBulletinContent(param).then((res) => {
          this.DetailData.publishdate = res.data.article.publishDate;
          this.DetailData.title = res.data.article.bulletinTitle;
          this.DetailData.readNum = res.data.article.readNum;
          this.DetailData.content = res.data.article.bulletinContent;
          this.DetailData.prjId = res.data.article.prjId;
          this.value = res.data.article.bulletinTypeId;
          this.changeid = res.data.article.autoId
          if(res.data.article.bulletinTypeId!=20){
              this.isNotice = true;
          }
          this.buyBtnShow = false;
          if (this.DetailData.prjId) {
            if (
              res.data.article.signUpEndDate &&
              res.data.article.signUpStartDate
            ) {
              let nowdate = new Date();
              let result = moment(nowdate).isBetween(
                res.data.article.signUpStartDate,
                res.data.article.signUpEndDate
              ); //当前时间是否开始时间和结束时间之间
              if (result) {
                this.buyBtnShow = true;
              }
            }
          }
        });
    },
    theDatebtn(start,end){
      var date = new Date();
      var myDate = new Date(date).getTime();
      var startDate = new Date(start).getTime();
      var endDate = new Date(end).getTime();
      if(start==null&&end==null){
        this.Datebtn = 0
      }else if (startDate > myDate) {
        this.Datebtn = 1
      }else if(startDate < myDate && endDate > myDate){
        this.Datebtn = 2
      }else if(endDate < myDate){
        this.Datebtn = 3
      }
    },
    buyBid() {
      window.open(
        "http://ygcg.nbcqjy.org:8061/login.html?PrjId=" + this.DetailData.prjId,
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.ant-radio-button-wrapper-disabled{
  cursor: default;
}
</style>
<style lang="less">
.z_detail_iframe {
  .main {
    padding: -24px;
  }
}

.ChangeClick{
  background-color: red;
}

/* table 样式 */
table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.timeul th{
  padding: 11px 16px!important;
}
table td,
table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
.z_detail_content img {
    max-width: 900px;
    height: auto;
    display: block;
    margin: auto;
    cursor: pointer;
}
label.ant-radio-button-wrapper {
    margin: 0 10px;
}
.ant-timeline{
  transform: rotate(270deg);
}
.ant-timeline li{
  display:inline-block;
}
.ant-timeline-item-content{
  transform: rotate(90deg);
  width: 100px!important;
  margin-right: -15px!important;
  margin-top: -12px!important;
}
.timeul ul{
  width: 100px;
  margin: auto;
  // margin: -80px 0 -145px 47%;
  // margin: -11% 0 -145px 47%;
}
.ant-timeline-item-tail{
  height: 110px;
}
.ant-timeline-item{
  height: 95px;
}
.ant-timeline-item:last-of-type{
  height: 52px;
}
.ant-timeline-item:last-of-type .ant-timeline-item-tail{
  display: none;
}
.ant-radio-button-wrapper-checked {
  bottom: 10px;
}
.ant-radio-button-wrapper-checked .shixin{
  display: block!important;
  width:0;
  height:0;
  border:10px solid transparent;
  border-top-color:#1890ff;
  position: relative;
  top: 2%;
  left:30%;
}

.ant-radio-button-wrapper{
  border-radius:unset!important;
}
</style>
